import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { getReportingTimeZone } from '@/lib/report-timezone';
import type { SupernovaFundedRow, SupernovaPagination } from './use-supernova-reconciliation';

export type { SupernovaFundedRow as FundingTransactionRow };

export interface FundingTransactionsListParams {
  locationId?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  perPage?: number;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
  // JSON-encoded Record<string, string> of per-column filter values, keyed
  // by the same field names used for sortBy.
  filters?: string;
}

interface FundingTransactionsListResponse {
  data: SupernovaFundedRow[];
  pagination: SupernovaPagination;
  range: Record<string, unknown>;
}

// Same underlying cc_funding_target_rows data as SuperNova Reconciliation's
// "Funded Transactions" tab (see getPayments in supernova-reconciliation-service.ts),
// served through its own route/module gate so this standalone page can be
// enabled independently of the Reconciliation module.
export function useFundingTransactions(params: FundingTransactionsListParams, enabled = true) {
  const timeZone = getReportingTimeZone();
  return useQuery<FundingTransactionsListResponse>({
    queryKey: ['funding-transactions', 'list', params, timeZone],
    queryFn: () =>
      api.get('/funding-transactions/report/list', {
        ...params,
        timeZone,
      } as Record<string, string | number | undefined>),
    enabled,
  });
}
